import React, { useMemo } from 'react';

import {
  useCompanies,
  useFormattedUser,
  useUserByAutodeskId,
} from '@adsk/alloy-provider';
import Avatar from '@adsk/alloy-react-avatar';
import HighlightText from '@adsk/alloy-react-highlight-text';
import theme from '@adsk/alloy-react-theme';
import { OverflowTooltip } from '@adsk/alloy-react-tooltip';

import { MentionData } from '../../consts';
import { useTranslation } from '../../i18n';

export const MentionUserSuggestion = ({
  suggestion,
  searchValue,
}: {
  suggestion: MentionData;
  searchValue?: string;
}) => {
  const { t } = useTranslation();
  const { user } = useUserByAutodeskId(suggestion.id?.toString() || '');
  const companies = useCompanies();
  const { formatDisplayUser } = useFormattedUser();

  const currentCompany = useMemo(
    () => companies.data.find((company) => company.id === user?.companyId),
    [companies.data, user?.companyId],
  );

  const formattedUserName = useMemo(
    () =>
      formatDisplayUser(suggestion.id).displayName ||
      suggestion.name ||
      t('NOT_AVAILABLE')?.toString(),
    [formatDisplayUser, suggestion.name, suggestion.id, t],
  );
  return (
    <>
      <Avatar
        style={{ fontWeight: 'normal' }}
        name={formattedUserName}
        imageUrl={user?.imageUrl}
      />
      <span
        style={{ marginLeft: 10 }}
        data-testid="MentionUserSuggestion_details"
      >
        <div
          style={{
            width: '100%',
            display: 'table',
            tableLayout: 'fixed',
          }}
        >
          <OverflowTooltip content={formattedUserName}>
            <HighlightText
              matched={searchValue}
              text={formattedUserName}
              style={{
                ...theme.typography.bodyMedium,
                color: theme.colors.charcoal900,
              }}
              highlightStyle={{
                ...theme.typography.bodyMediumBold,
                backgroundColor: 'transparent',
              }}
            />
          </OverflowTooltip>

          <div
            style={{
              ...theme.typography.bodySmall,
              color: theme.colors.charcoal700,
            }}
          >
            <OverflowTooltip content={currentCompany?.name}>
              {currentCompany?.name}
            </OverflowTooltip>
          </div>
        </div>
      </span>
    </>
  );
};
